import { parseAnything } from '@scalar-org/helpers/parse'
import { scalarConfigSchema } from '@scalar-org/scalar-config'

import { Command } from 'commander'
import fs from 'node:fs'
import as from 'ansis'

import { findConfig } from '../helpers'
import { output } from '@/helpers/std-out'

/**
 * Lint users scalar configs (scalar.config.json files)
 */
export function CheckConfigCommand() {
  const cmd = new Command('check-config')

  cmd.description('Check a Scalar Configuration file')
  cmd.argument('[file]', 'File to check')
  cmd.action(async (inputArgument: string) => {
    const startTime = performance.now()

    // Read file
    const file = findConfig(inputArgument)

    // Check if configuration file was found
    if (!file) {
      return output
        .error()
        .title('Invalid configuration file')
        .message('Could not find the Scalar Configuration file:')
        .message(inputArgument)
        .exit('error')
    }

    const fileContent = fs.readFileSync(file, 'utf-8')
    const data = parseAnything(fileContent)

    if (!data.success) {
      return output
        .error()
        .title('Invalid configuration file')
        .line('Could not parse the Scalar Configuration file:')
        .message(file)
        .exit('error')
    }

    // Validate
    const result = scalarConfigSchema.safeParse(data.data)

    if (result.success) {
      const endTime = performance.now()

      output
        .info()
        .line(
          `${as.green('[SUCCESS]')} ${as.green('The Scalar Configuration is valid:')} ${as.green(file)}`,
        )
        .line(
          `${as.green('Scalar Configuration validated')} ${as.grey(
            `in ${as.white.bold(`${Math.round(endTime - startTime)} ms`)}`,
          )}\n`,
        )
        .print()
    } else {
      output
        .error()
        .title('The given Scalar Configuration is invalid.')
        .message(file)
        .print()

      if (result.error.issues) {
        output
          .error()
          .table(
            result.error.issues.map((error) => [
              as.yellow(`${error.path.join('/').trim() || 'root'}:`),
              error.message,
            ]),
            { padding: 2 },
          )
          .print()
      }
      return output.error().exit('error')
    }
  })

  return cmd
}
